import * as Yup from 'yup'

export const notesValidationRules = Yup.object().shape({
  notes: Yup.string().nullable()
});